import styled from 'styled-components'

export const Box = styled.div`
  background: none;
  padding: 1rem;
  padding-top: 2rem;
  text-align: center;

  a {
    border-bottom: none;
  }
  img {
    width: 70%;
    max-width: 300px;
  }
  h2 {
    padding-top: 1rem;
    font-size: 1.5rem;
    font-family: 'Open Sans', serif !important;
    color: #d7d7d7;
  }
`



// WEBPACK FOOTER //
// ./src/components/Elements/Box.js